// extracted by mini-css-extract-plugin
export default {"cls1":"THNL5ZoDdOyQVnaSBjPQ","cls2":"WikLkSVE4qLZ1kCoWcRQ THNL5ZoDdOyQVnaSBjPQ"};